export const FakeData = [{
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
    {
        'id': 1,
        'name': 'احسان',
        'family': 'آقاحسینی',
        'age': '23 سال',
        'born': '1994',
        'city': 'اصفهان',
        'state': 'استان اصفهان',
        'phone': '0936000000',
        'skill': 'توسعه دهنده وب',
        "icon": "/assetes/svg/dashboard.svg#dashboard"
    },
]